import { trace } from 'rytm-helpers'
import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'

class MaskedView extends View {

  constructor(id) {
    super(id)
  }
    /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const list = [...container.querySelectorAll(".masked-element")]
    list.forEach(this._showListItem.bind(this))
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    const list = [...container.querySelectorAll(".masked-element")]
    list.forEach(this._hideListItem.bind(this))
  }
  /**
   * OWN
   */
  _showListItem(el, index) {
    const delay = index * .08
    const dY = el.dataset.y ? el.dataset.y : 1
    const y = window.innerHeight * dY
    TweenMax.killTweensOf(el)
    TweenMax.from(el, .6, {y, delay, ease: Expo.easeOut})
  }
  _hideListItem(el, index) {
    const delay = index * .08
    const dY = el.dataset.y ? el.dataset.y : 1
    const y = window.innerHeight * dY
    TweenMax.killTweensOf(el)
    TweenMax.to(el, .4, {y, delay, ease: Expo.easeIn})
  }

}

export default MaskedView